import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { theme } from 'antd';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store/configureStore';
import CardComponent from 'components/CardComponent';
import whoAmIWorkflow from 'constants/whoAmIWorkflow';
import WhoAmILayout from 'components/Layouts/WhoAmILayout/WhoAmILayout';
import i18n from 'constants/translation/i18n';
import * as Styled from '../WhoAmI.styled';

const { useToken } = theme;

const WhoAmI: React.FC = () => {
  const navigate = useNavigate();
  const { token } = useToken();
  const whoAmICards = whoAmIWorkflow();

  const { scheme, lang } = useSelector((state: RootState) => ({
    scheme: state.global.scheme,
    lang: state.global.lang
  }));

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  const handleCardClick = (item: {
    area: string;
    title: string;
    href: string;
  }) => {
    if (item.href) {
      navigate(item.href);
    }
  };

  return (
    <WhoAmILayout>
      <Styled.HorizontalLayout theme={scheme}>
        <Styled.Container>
          <Styled.GridContainer token={token}>
            {whoAmICards.map((item) => (
              <Styled.RelativeContainer
                key={item.area}
                onClick={() => handleCardClick(item)}
              >
                <CardComponent
                  area={item.title}
                  infoText={''}
                  href={item.href}
                  textOnTop=''
                />
              </Styled.RelativeContainer>
            ))}
          </Styled.GridContainer>
        </Styled.Container>
      </Styled.HorizontalLayout>
    </WhoAmILayout>
  );
};

export default WhoAmI;
